import React from 'react'

const BetaBadge = ({ className = '', compactOnMobile = false }) => {
    return (
        <span className={`inline-flex items-center gap-1 rounded-md border border-cyan-700/35 bg-cyan-900/18 px-1.5 py-0.5 text-[8px] font-semibold uppercase tracking-[0.12em] text-cyan-100 sm:gap-1.5 sm:px-2 sm:text-[9px] sm:tracking-[0.18em] ${className}`}>
            {compactOnMobile ? (
                <>
                    <span className="sm:hidden">β</span>
                    <>
                        <span aria-hidden="true" className="hidden h-1.5 w-1.5 rounded-full bg-cyan-300/90 sm:inline-block" />
                        <span className="hidden sm:inline">Beta</span>
                    </>
                </>
            ) : (
                <>
                    <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-cyan-300/90" />
                    <span>Beta</span>
                </>
            )}
        </span>
    )
}

export default BetaBadge
